import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotification = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_7059_61368)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M2.0625 12.045V16.9449H21.9422V12.045C21.9422 8.22749 20.7303 4.97357 18.3549 2.97394C16.7588 1.63042 14.6342 0.843751 11.9756 0.843751C9.35514 0.842935 7.24626 1.62437 5.65549 2.96468C3.28924 4.95836 2.0625 8.20911 2.0625 12.045ZM3.0225 15.9849V12.045C3.0225 8.52658 4.10365 5.52749 6.27407 3.69884C7.70768 2.49092 9.61372 1.80303 11.9753 1.80375H11.9754C14.3741 1.80375 16.2967 2.49625 17.7366 3.70839C19.9152 5.54228 20.9822 8.54391 20.9822 12.045V15.9849H3.0225Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M0.0175781 21.4037H23.9776L21.7819 15.9375H2.21329L0.0175781 21.4037ZM22.5575 20.4437H1.43775L2.86225 16.8975C5.15132 16.8975 18.8439 16.8975 21.133 16.8975L22.5575 20.4437Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M9.72656 20.9062C9.72656 21.5222 9.91021 22.081 10.2779 22.4902C10.6483 22.9022 11.2096 23.1776 12.0022 23.1776C12.795 23.1776 13.3564 22.901 13.7268 22.4882C14.0945 22.0784 14.2779 21.5195 14.2779 20.9062H13.3179C13.3179 21.2684 13.2294 21.6051 13.0123 21.8471C12.7977 22.0862 12.4615 22.2176 12.0022 22.2176C11.5429 22.2176 11.2065 22.0872 10.992 21.8484C10.7748 21.6068 10.6866 21.27 10.6866 20.9062H9.72656Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7059_61368",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNotification);
export default ForwardRef;
